import styled from 'styled-components';

import {
	SYS_BREAKPOINT_2_XL,
	SYS_BREAKPOINT_LG,
	SYS_BREAKPOINT_MD,
	SYS_BREAKPOINT_XL,
	SYS_PAGE_MARGIN_2_XL,
	SYS_PAGE_MARGIN_LG,
	SYS_PAGE_MARGIN_MD,
	SYS_PAGE_MARGIN_SM,
	SYS_PAGE_MARGIN_XL,
	SYS_SPACE_FIXED_200,
	SYS_SPACE_FIXED_700,
} from '@oneaudi/unified-web-common';
import { customBreakPoint, mobileBreakPoint } from '~/styles/break-points';

export const SelectionStepSectionStyle = styled.section<{ $hide: boolean | undefined }>`
	display: ${(props) => (props.$hide ? 'none' : 'flex')};
	flex-direction: column;
	width: 100%;
	height: max-content;

	.gallery-wrapper {
		display: flex;
		flex-direction: column;
		width: 100%;
		min-width: 0;
		position: relative;
		top: 0;
		z-index: 9;
		height: max-content;
		${customBreakPoint(
			mobileBreakPoint,
			`
			position: sticky;
		`,
		)}
	}

	.step-headline-container {
		& > div:nth-child(1) {
			margin-bottom: ${SYS_SPACE_FIXED_200};
		}
		& > div:nth-child(2) {
			margin-bottom: ${SYS_SPACE_FIXED_200};
		}

		padding: 0 ${SYS_PAGE_MARGIN_SM};

		@media screen and (min-width: ${SYS_BREAKPOINT_MD}) {
			padding-left: ${SYS_PAGE_MARGIN_MD};
			padding-right: ${SYS_PAGE_MARGIN_MD};
		}

		@media screen and (min-width: ${SYS_BREAKPOINT_LG}) {
			padding-left: ${SYS_PAGE_MARGIN_LG};
			padding-right: ${SYS_PAGE_MARGIN_LG};
		}

		@media screen and (min-width: ${SYS_BREAKPOINT_XL}) {
			padding-left: ${SYS_PAGE_MARGIN_XL};
			padding-right: ${SYS_PAGE_MARGIN_XL};
		}

		@media screen and (min-width: ${SYS_BREAKPOINT_2_XL}) {
			padding-left: ${SYS_PAGE_MARGIN_2_XL};
			padding-right: ${SYS_PAGE_MARGIN_2_XL};
		}
	}

	.step-headline-container-desktop {
		display: flex;
		flex-direction: column;
		width: 100%;
		& > div:nth-child(1) {
			margin-bottom: ${SYS_SPACE_FIXED_200};
		}
		& > div:nth-child(2) {
			margin-bottom: ${SYS_SPACE_FIXED_200};
		}
	}

	${customBreakPoint(
		mobileBreakPoint,
		`
			flex-direction: row-reverse;
		`,
	)}

	.comparison-dialog-wrapper {
		margin-bottom: 24px;
		margin-top: -8px;

		.comparison-dialog {
			width: fit-content;
			& > div > div:last-of-type {
				width: 100%;
			}
		}
	}
`;

export const ConfigurationStepStyle = styled.div`
	padding: 56px ${SYS_PAGE_MARGIN_SM} 72px ${SYS_PAGE_MARGIN_SM};
	max-width: 100%;
	width: 100%;

	.headline-overwrite {
		display: flex;
		flex-direction: column;
		gap: 20px;
	}

	@media screen and (min-width: ${SYS_BREAKPOINT_MD}) {
		padding-left: ${SYS_PAGE_MARGIN_MD};
		padding-right: ${SYS_PAGE_MARGIN_MD};
	}

	@media screen and (min-width: ${SYS_BREAKPOINT_LG}) {
		padding-left: ${SYS_PAGE_MARGIN_LG};
		padding-right: ${SYS_PAGE_MARGIN_LG};
	}

	@media screen and (min-width: ${SYS_BREAKPOINT_XL}) {
		padding-right: ${SYS_PAGE_MARGIN_XL};
	}

	@media screen and (min-width: ${SYS_BREAKPOINT_2_XL}) {
		padding-right: ${SYS_PAGE_MARGIN_2_XL};
	}

	${customBreakPoint(
		mobileBreakPoint,
		`
			padding-left: ${SYS_SPACE_FIXED_700} !important;
			max-width: 540px;
			min-width: 540px;
		`,
	)}
`;
